<template>
	<div class="search">
		<Select @on-change="choose" @on-query-change="toQuery" key="search" filterable clearable remote :remote-method="remoteMethod1" :loading="loading1" placeholder="检索">
			<span slot="prefix" class="iconfont icon-sousuo"></span>
			<Option v-for="(option, index) in options1" :value="option.value" :key="option.value">
				<div style="width: 200px;" class="single">{{option.label}}</div>
			</Option>
		</Select>
	</div>
</template>
<script>
	import {
		getArticle
	} from '@/api/home/index'
	export default {
		name: 'Search',
		props: {
			isBlue: {
				type: Boolean,
				default: false
			},
		},
		data() {
			return {
				loading1: false,
				options1: [],
				list: []
			}
		},
		mounted() {

		},
		methods: {
			toQuery(query){
				if (query !== '') {
					this.loading1 = true;
					getArticle({
						keywords: query,
						pageNo: 1,
						pageSize: 10,
					}).then(res => {
						if (res.code == 200 || res.code == 0) {
							this.list = res.result.records;
							const list = this.list.map(item => {
								return {
									value: item.id,
									label: item.title
								};
							});
							// console.log(22,query.toLowerCase())
							this.options1 = list;
							// console.log(333,this.options1)
							this.loading1 = false;
						} else {
							this.list = [];
							this.loading1 = false;
						}
					})
				} else {
					this.options1 = [];
				}
			},
			remoteMethod1(query) {
				
			},
			choose(e){
				this.$router.push({
					name: 'news_detail',
					query: {
						id: e,
					},
					params: {
						locationList: encodeURIComponent(JSON.stringify(['首页','检索']))
					}
				});
			},
		}
	}
</script>
<style lang="scss" scoped>
	.search {
		background-color: rgba(0, 0, 0, .5);
		border-radius: 20px;
		width: 150px;

		.icon-sousuo {
			padding: 0 0 0 10px;
		}


		.icon-sousuo {
			margin-right: 10px;
			color: #fff;
		}

		input {
			outline-style: none
		}

		/deep/ .ivu-select-input {
			padding: 0 15px 0 0;
			color: #fff;
			font-size: 14px;
		}

		/deep/ .ivu-select-selection {
			background-color: transparent !important;
			border-radius: 20px;
			border: none;
			outline-style: none;
			height: 30px;
		}
	}
</style>
